export function createCancellationToken() {
  var isCancelled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    isCancelled: isCancelled
  };
}